<script>
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Button from '@/components/Button'
import StringUils from '@/utils/stringUtils'
import emailjs from 'emailjs-com'

const STEPS =
{
    EMAIL: 0,
    TOWN_HALL: 1,
    CONTACT: 2,
    MESSAGE: 3,
    DONE: 4
}

export default
{
    name: 'trial-request',

    render () 
    {
        return (
            <div id='trial-request-view'>
                <div id='form'>
                    <div id='step-title'>{ this.stepTitle }</div>
                    <div id='step-content' ref='stepContent'>
                        <div v-show={this.currentStep == STEPS.EMAIL} class='email-step-content step-content-container'>
                            <floating-label-text-input v-model={this.email} placeholder='Votre courriel' type='email'
                                icon={require('@/assets/img/envelope.svg')} on-enter={this.tryGoNextStep} />
                        </div>
                        <div v-show={this.currentStep == STEPS.TOWN_HALL} class='town-hall-step-content step-content-container'>
                            <div class='inputs-row'>
                                <floating-label-text-input v-model={this.cityName} placeholder='Le nom de votre commune' />
                                <span class='text-separator'> et </span>
                                <floating-label-text-input v-model={this.cityZipCode} placeholder='Son code postal'
                                    class='zip-code' on-enter={this.tryGoNextStep} />
                            </div>
                        </div>
                        <div v-show={this.currentStep == STEPS.CONTACT} class='contact-step-content step-content-container'>
                            <div class='inputs-row'>
                                <floating-label-text-input v-model={this.bookerLastName} placeholder='Nom' />
                                <floating-label-text-input v-model={this.bookerFirstName} placeholder='Prénom' />
                            </div>
                            <div class='inputs-row'>
                                <floating-label-text-input v-model={this.bookerJobName} placeholder='Titre' />
                                <floating-label-text-input v-model={this.bookerPhone} placeholder='Téléphone'
                                    on-enter={this.tryGoNextStep} />
                            </div>
                        </div>
                        <div v-show={this.currentStep == STEPS.MESSAGE} class='message-step-content step-content-container'>
                                <floating-label-text-input v-model={this.bookerMessage} placeholder='Entrer votre message ici'
                                    on-enter={this.tryGoNextStep} />
                        </div>
                        <div v-show={this.currentStep == STEPS.DONE} class='done-step-content step-content-container'>
                            Nous vous contacterons sous 72h pour convenir d'un rendez-vous et discuter avec vous des formalités.
                            <br />
                            <br />
                            Si vous avez la moindre question pendant ce temps vous pouvez nous contacter à <b>support@app-maville.com</b> ou directement
                             utiliser le support en ligne en cliquant sur la <b>bulle en bas à droite</b>.
                            <br />
                            <br />
                            Nous sommes impatients de collaborer avec vous 😊
                            <br />
                            <br />
                            ─ L'équipe Ma Ville
                        </div>
                    </div>
                    <Button type={this.canAccessNextStep ? 'secondary' : 'disabled'} v-show={this.currentStep != STEPS.DONE}
                        on-click={this.tryGoNextStep} is-loading={this.isFormLoading} text='Continuer' />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
            isFormLoading: false,
            currentStep: STEPS.EMAIL,
            email: '',
            cityName: '',
            cityZipCode: '',
            bookerLastName: '',
            bookerFirstName: '',
            bookerJobName: '',
            bookerPhone: '',
            bookerMessage: '',
        }
    },

    computed:
    {
        stepTitle ()
        {
            switch (this.currentStep)
            {
                case STEPS.EMAIL:
                    return 'Comment pouvons-nous vous contacter ?'
                case STEPS.TOWN_HALL:
                    return 'Quelle commune représentez-vous ?'
                case STEPS.CONTACT:
                    return 'Qui devons-nous contacter pour la mise en place de votre nouvelle application ?'
                case STEPS.MESSAGE:
                    return 'Avez-vous des informations supplémentaires à nous transmettre ?'
                case STEPS.DONE:
                    return 'Votre application est bientôt prête ! 🎉'
            }
        },

        canAccessNextStep ()
        {
            switch (this.currentStep)
            {
                case STEPS.EMAIL:
                    return StringUils.isValidEmail(this.email)

                case STEPS.TOWN_HALL:
                    return !StringUils.isAnyEmptyString([ this.cityName, this.cityZipCode ])

                case STEPS.CONTACT:
                    return !StringUils.isAnyEmptyString([ this.bookerLastName, this.bookerFirstName, this.bookerJobName, this.bookerPhone ])
            }

            return true
        }
    },
    
    mounted ()
    {
    },

    methods:
    {
        async tryGoNextStep ()
        {
            if (this.canAccessNextStep)
            {
                if (this.currentStep + 1 == STEPS.DONE)
                {
                    await this.sendBookingMail()
                }

                this.$refs.stepContent.classList.add('loading')
                this.currentStep += 1
                setTimeout(() => this.$refs.stepContent.classList.remove('loading'), 100)
            }
        },

        async sendBookingMail ()
        {
            const params =
            {
                'reply_to': this.email,
                'subject': `[Demande Essai] : Mairie de ${this.cityName}`,
                'body': JSON.stringify({ email: this.email, cityName: this.cityName, cityZipCode: this.cityZipCode, bookerLastName: this.bookerLastName,
                    bookerFirstName: this.bookerFirstName, bookerJobName: this.bookerJobName, bookerPhone: this.bookerPhone, bookerMessage: this.bookerMessage })
            }

            const serviceId = 'smtp_server';
            const templateId = 'template_free_trial_request';
            const token = 'user_74zgUTApRC87A3k89Et6X'
            
            this.isFormLoading = true
            await emailjs.send(serviceId, templateId, params, token);
            this.isFormLoading = false
        }
    },

    components:
    {
        FloatingLabelTextInput,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#trial-request-view
{
    min-height: 100vh;
    min-width: 100vw;
    display: flex;
    justify-content: center;
    background: rgb(119,111,249);
    background: linear-gradient(160deg, var(--theme-accent-color) 46%, rgba(171,0,255,1) 100%);
    color: #ffffffc0;

    ::selection
    {
        background: #ffffff50;
    }

    b
    {
        color: white;
    }

    #form
    {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-top: 15vh;

        .OnDesktop({ margin-top: 22vh; });

        #step-title
        {
            margin-bottom: 5vh;
            color: white;
            font-family: Inter, Arial;
            font-weight: bolder;
            text-align: center;
            margin-left: 5vw;
            margin-right: 5vw;
            font-size: 7vw;

            .OnTablet({ font-size: 5vw; });
            .OnDesktop({ font-size: 2.5vw; });
            .OnLarge({ font-size: 2vw; });
        }

        #step-content
        {
            width: 100%;
            display: flex;
            justify-content: center;
            opacity: 1;
            transition: all 0.1s ease-in-out;

            &.loading
            {
                transition: none;
                opacity: 0;
            }

            .step-content-container
            {
                &.email-step-content
                {
                    width: 90%;

                    .OnTablet({ width: 70%; });
                    .OnDesktop({ width: 30%; });
                }

                &.town-hall-step-content
                {
                    width: 90%;

                    .OnTablet({ width: 85%; });
                    .OnDesktop({ width: 45%; });
                    .OnLarge({ width: 30%; });

                    .inputs-row
                    {
                        .OnMobile({ flex-direction: column; });

                        .text-separator
                        {
                            .OnMobile({
                                font-size: 5vw;
                                margin-top: 3vh;
                                margin-bottom: 3vh;
                            });
                        }

                        .floating-label-text-input
                        {
                            width: 100%;

                            &.zip-code
                            {
                                .OnMobile({ width: 100%; });
                                .OnTablet({ width: 65%; });

                                width: 55%;
                            }
                        }
                    }
                }

                &.contact-step-content
                {
                    width: 90%;

                    .OnTablet({ width: 75%; });
                    .OnDesktop({ width: 40%; });
                    .OnLarge({ width: 30%; });
                }

                &.message-step-content
                {
                    width: 90%;

                    .OnTablet({ width: 70%; });
                    .OnDesktop({ width: 30%; });
                }

                &.done-step-content
                {
                    width: 90%;
                    font-size: 5vw;

                    .OnTablet({
                        width: 70%;
                        font-size: 3vw
                    });

                    .OnDesktop({
                        font-size: 1.4vw;
                        width: 50%;
                    });

                    .OnLarge({ font-size: 1.2vw; });
                }
            }

            .inputs-row
            {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                margin-bottom: 3vh;

                .floating-label-text-input
                {
                    width: 48%;
                }

                .text-separator
                {
                    align-self: center;
                    margin: 0 2.5vw;
                    font-size: 3vw;

                    .OnDesktop({
                        margin: 0 1vw;
                        font-size: 1vw;
                    })
                }
            }
        }

        .floating-label-text-input
        {
            color: white;
            height: 13vw;
            font-size: 4vw;

            .OnTablet({
                height: 9vw;
                font-size: 3vw
             });
            
            .OnDesktop({
                height: 6vh;
                font-size: 1.5vw;
            });

            .OnLarge({
                font-size: 1vw;
            });

            .field-placeholder
            {
                color: white;
            }

            .field-icon
            {
                fill: white;
            }
        }

        .button
        {
            color: var(--theme-text-color);
            width: 90%;
            margin-top: 5vh;
            padding-top: 3vw;
            padding-bottom: 3vw;

            .OnTablet({ width: 70%; });

            .OnDesktop({
                width: 30%;
                padding-top: 2vh;
                padding-bottom: 2vh;
            });

            .OnLarge({
                padding-top: 2vh;
                padding-bottom: 2vh;
            });

            &:not(.disabled)
            {
                background-color: #ffffffe0;
            }

            &.disabled
            {
                color: white;
            }

            &:hover
            {
                background-color: white;
                color: var(--theme-text-color);
                box-shadow: 0 0 15px 2px #00000030;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/TrialRequest.vue